import { REVENUE_TYPE } from 'constants/revenue';

export const isRevenueIndependentType = revenueType => revenueType === REVENUE_TYPE.independent;
export const isRevenueVirtualType = revenueType => revenueType === REVENUE_TYPE.virtual;
